<template>
  <div class="apply">
    <nav-bar
      fixed
      z-index="99"
      title="游戏创建"
      left-text="返回"
      left-arrow
      placeholder
      @click-left="$router.go(-1)"
    />
    <div class="apply-card">
      <nf-card borderInnerSize="0" bgColor="#fff" :dash="false">
        <div class="apply-card-info">
          <img class="apply-card-info-avatar" :src="userInfo.avatar" alt="" />
          <div class="apply-card-info-des">
            <div class="apply-card-info-des-title">{{ userInfo.realName }}</div>
            <div class="apply-card-info-des-text">
              <!-- {{ userInfo }} -->
            </div>
          </div>
        </div>
      </nf-card>
    </div>

    <div class="apply-content">
      <div class="apply-content-title">游戏名称：</div>
      <div style="margin-bottom: 0.02rem">
        <!-- <div style="flex-shrink: 0">游戏名称：</div> -->
        <NfInput
          width="100%"
          round=".1rem"
          borderInnerSize="0.01rem"
          type="text"
          :value.sync="form.gameName"
        />
      </div>
      <div class="apply-content-title">游戏准备</div>
      <div class="apply-content-item">
        <nf-card
          class="apply-content-item-box"
          padding="0.1rem"
          borderSize="0"
          bgColor="#fff"
          round="0.2rem"
          shadow
        >
          <nf-card
            bgColor="#fff"
            borderSize="0"
            :shadow="true"
            class="apply-content-item-box-title"
            width="80%"
            round=".3rem"
            padding="0.1rem 0.3rem"
          >
            1、请选择游戏类型，确认参与游戏人数
          </nf-card>
          <div class="apply-content-item-box-data">
            <div class="apply-content-item-box-data-box">
              <div class="apply-content-item-box-data-box-item">
                <RadioGroup v-model="form.gameType">
                  <Radio :name="1">
                    1对1游戏
                    <template #icon="props">
                      <img
                        class="apply-content-item-box-data-box-item-icon"
                        :src="props.checked ? activeIcon : inactiveIcon"
                      />
                    </template>
                  </Radio>
                  <Radio :name="2">
                    1对多游戏
                    <template #icon="props">
                      <img
                        class="apply-content-item-box-data-box-item-icon"
                        :src="props.checked ? activeIcon : inactiveIcon"
                      />
                    </template>
                  </Radio>
                  <Radio :name="3">
                    1对家庭游戏
                    <template #icon="props">
                      <img
                        class="apply-content-item-box-data-box-item-icon"
                        :src="props.checked ? activeIcon : inactiveIcon"
                      />
                    </template>
                  </Radio>
                </RadioGroup>
              </div>
              <div
                class="apply-content-item-box-data-box-item"
                style="border-left: 1px solid #ddd"
              >
                <div>游戏人数：</div>
                <div style="margin-top: 0.1rem">
                  <!-- <NfDropdownMenu
                    :value.sync="form.playersNum"
                    :options="numOptions"
                  ></NfDropdownMenu> -->
                  <NfPopover
                    :value.sync="form.playersNum"
                    :options="numOptions"
                  ></NfPopover>
                </div>
              </div>
            </div>
          </div>
        </nf-card>
      </div>

      <div class="apply-content-item">
        <nf-card
          borderInnerSize="0"
          class="apply-content-item-box"
          :dash="false"
          bgColor="#fff"
          round="0.2rem"
          borderSize="0"
          shadow
        >
          <nf-card
            bgColor="#fff"
            class="apply-content-item-box-title"
            width="80%"
            round=".3rem"
            borderSize="0"
            padding="0.1rem 0.3rem"
            shadow
          >
            2、初始化卡牌设置
          </nf-card>
          <div class="apply-content-item-box-data">
            <Grid :column-num="2" :border="false" gutter="0.2rem">
              <template v-for="item in cardList">
                <GridItem :key="item.id">
                  <nf-card
                    @click.native="
                      changeCardType(item.id, item.cardCategoryName)
                    "
                    :borderColor="form.cateId == item.id ? '#ACB9E8' : ''"
                    :borderSize="form.cateId == item.id ? '0.01rem' : '0.01rem'"
                    round="0.3rem"
                    class="apply-content-item-box-data-card"
                  >
                    <div class="apply-content-item-box-data-card-top">
                      {{ item.cardCategoryName }}
                    </div>
                    <div class="apply-content-item-box-data-card-center">
                      <img
                        class="apply-content-item-box-data-card-center-img"
                        :src="item.secondImg || item.img"
                        mode="scaleToFill"
                      />
                    </div>
                    <div class="apply-content-item-box-data-card-bottom">
                      <RadioGroup
                        v-model="form.secondCateId"
                        class="apply-content-item-box-data-card-bottom-group"
                      >
                        <template v-for="subItem of item.children">
                          <Radio
                            :name="subItem.id"
                            :key="subItem.id"
                            @click.prevent="changeSubCardType(item, subItem)"
                          >
                            {{ subItem.cardCategoryName }}
                            <template #icon="props">
                              <img
                                class="apply-content-item-box-data-box-item-icon"
                                :src="props.checked ? activeIcon : inactiveIcon"
                              />
                            </template>
                          </Radio>
                        </template>
                      </RadioGroup>
                    </div>
                  </nf-card>
                </GridItem>
              </template>
            </Grid>
            <div class="apply-content-item-box-data-select">
              <div>本轮最多可抽</div>
              <!-- <NfDropdownMenu
                style="margin: 0 0.1rem"
                width="2rem"
                :value.sync="form.extractNum"
                :options="drawNumOptions"
              ></NfDropdownMenu> -->
              <NfInput
                width="20%"
                round=".1rem"
                borderInnerSize="0.01rem"
                type="text"
                :value.sync="form.extractNum"
                :disabled="limitDisabled"
              />
              <div>张卡牌</div>
            </div>
            <!-- <div class="apply-content-item-box-data-select">
              <div style="flex-shrink: 0;">游戏名称：</div>
              <NfInput
                width="100%"
                round=".1rem"
                borderInnerSize="0.01rem"
                type="text"
                :value.sync="form.gameName"
              />
            </div> -->
          </div>
        </nf-card>
      </div>

      <div class="apply-content-item">
        <nf-card
          borderInnerSize="0"
          class="apply-content-item-box"
          :dash="false"
          bgColor="#fff"
        >
          <nf-card
            bgColor="#fff"
            class="apply-content-item-box-title"
            width="80%"
            round=".3rem"
            padding="0.1rem 0.3rem"
          >
            3、设置入会密码（可选项）
          </nf-card>
          <div class="apply-content-item-box-data">
            <div class="apply-content-item-box-data-setting">
              <div class="apply-content-item-box-data-setting-text">密码：</div>
              <NfInput
                width="80%"
                borderInnerSize="0"
                :value.sync="form.password"
              />
              <NfButton fontColor="#fff" color="#72C07B" @click.native="randomPassword">生成随机密码</NfButton>
              <!-- <NfButton @click.native="generateLinkHandle"
                >生成游戏链接</NfButton
              > -->
            </div>
            <!-- <div class="apply-content-item-box-data-setting">
              <div class="apply-content-item-box-data-setting-text">
                游戏链接：
              </div>
              <NfButton width="25%" @click.native="copyLink">复制链接</NfButton>
            </div> -->
            <!-- <div class="apply-content-item-box-data-setting">
              <NfInput
                borderSize="0"
                type="text"
                :value.sync="form.gameUrl"
                disabled
              />
            </div> -->
          </div>
        </nf-card>
      </div>

      <div class="apply-content-item">
        <NfButton round="50px" fontSize="0.3rem" @click.native="nextHandle">创建游戏</NfButton>
      </div>
    </div>
  </div>
</template>

<script>
import { Image, Radio, RadioGroup, Grid, GridItem, NavBar } from "vant";
import { generateLink, cardCategoryList, createGame } from "@/api/game";

import NfCard from "@/components/game-ui/NfCard.vue";
import NfInput from "@/components/game-ui/NfInput.vue";
import NfButton from "@/components/game-ui/NfButton.vue";
import NfDropdownMenu from "@/components/game-ui/NfDropdownMenu.vue";
import NfPopover from "@/components/game-ui/NfPopover.vue";
import activeIcon from "@/assets/game/checked.png";
import inactiveIcon from "@/assets/game/no_checked.png";
import { getGameConfig } from "../config";

export default {
  components: {
    NfCard,
    Image,
    Radio,
    RadioGroup,
    Grid,
    GridItem,
    NfDropdownMenu,
    NfButton,
    NfInput,
    NavBar,
    NfPopover,
  },
  data() {
    return {
      activeIcon,
      inactiveIcon,
      form: {
        // 游戏类型
        gameType: 1,
        // 人数
        playersNum: 1,
        cateId: 0,
        cateName: "",
        secondCateId: 0,
        secondCateName: "",
        // 本轮最多可抽
        extractNum: 1,
        // 密码
        password: "",
        // 游戏链接
        // gameUrl: "",
        gameName: "",
      },
      numOptions: [{ text: "1人", value: 1 }],
      drawNumOptions: [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
      ],
      cardList: [],
      userInfo: {},
      limitDisabled: false,
    };
  },
  mounted() {
    this.cardCategoryList();
    this.userInfo = this.$store.state.app.userInfo;
  },
  methods: {
    changeCardType(value, name) {
      console.log("触发一级");
      // if (value != this.form.cateId) {
      const item = this.cardList.find((item) => item.id === value);
      if (item.children.length > 0) {
        this.changeSubCardType(item, item.children[0]);
      } else {
        this.form.secondCateId = 0;
      }
      // }
      this.form.cateId = value;
      this.form.cateName = name;
      // this.form.secondCateId = 0;
    },
    changeSubCardType(item, secondItem) {
      this.form.secondCateId = 0;

      console.log("二级改变", item, secondItem);
      item.secondImg = secondItem.img;

      this.form.secondCateId = secondItem.id;
      this.form.secondCateName = secondItem.cardCategoryName;
      this.changeLimitNum(item.id, secondItem.id);
    },
    generateLinkHandle() {
      generateLink().then((res) => {
        if (res.success) {
          this.form.gameUrl = res.data;
          this.$dialog.message("生成成功");
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    // 创建游戏
    nextHandle() {
      if (this.form.cateId === 0) {
        this.$dialog.message("请选择卡牌类型");
        return;
      }
      if (this.form.gameName === "") {
        this.$dialog.message("请先给游戏起个名字");
        return;
      }
      createGame(this.form)
        .then((res) => {
          if (res.success) {
            this.$dialog.message("游戏创建成功，即将进入游戏");
            this.$router.push({
              path: "/game/choose",
              query: {
                gameId: res.data,
              },
            });
          } else {
            this.$dialog.message(res.msg);
          }
        })
        .catch((err) => {
          this.$dialog.message(err.msg);
        });
    },
    cardCategoryList() {
      cardCategoryList().then((res) => {
        if (res.success) {
          this.cardList = res.data;
        }
      });
    },
    // 设置随机密码
    randomPassword() {
      this.form.password = Math.random().toString(36).slice(-4);
    },
    // 复制链接
    copyLink() {
      if (!this.form.gameUrl) {
        this.$dialog.message("请先生成游戏链接!");
        return;
      }
      // 原生复制
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", this.form.gameUrl);
      input.style.position = "absolute";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, 9999);
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      this.$dialog.message("复制成功");
    },
    changeLimitNum(cateId, secondCateId) {
      const config = getGameConfig(cateId, secondCateId);
      console.log("limitNum", limitNum, config, cateId, secondCateId);
      const limitNum = config.limitNum;
      if (limitNum !== undefined) {
        this.form.extractNum = limitNum;
        this.limitDisabled = true;
      } else {
        this.limitDisabled = false;
        this.form.extractNum = 1;
      }
    },
  },
  watch: {
    "form.gameType": {
      handler(val) {
        if (val === 1) {
          this.form.playersNum = 1;
          this.numOptions = [{ text: "1人", value: 1 }];
        } else {
          this.form.playersNum = 2;
          // 生成50人
          this.numOptions.splice(0, this.numOptions.length);
          for (let i = 2; i <= 50; i++) {
            this.numOptions.push({ text: `${i}人`, value: i });
          }
        }
      },
    },
    "form.secondCateId": {
      handler(val) {
        const config = getGameConfig(this.form.cateId, val);
        const limitNum = config.limitNum || null;
        if (limitNum) {
          this.form.extractNum = limitNum;
          this.limitDisabled = true;
        } else {
          this.limitDisabled = false;
          this.form.extractNum = 1;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.apply {
  background-color: rgb(172, 185, 232);

  &-card {
    padding: 0.4rem;
    padding-top: 0.3rem;

    &-info {
      display: flex;
      align-items: center;
      padding: 0.1rem;
      &-avatar {
        width: 1rem;
        height: 1rem;
        border-radius: 15%;
      }
      &-des {
        margin-left: 0.2rem;
        &-title {
          font-size: 0.25rem;
          font-weight: bold;
          line-height: 1.8;
        }
        &-text {
          font-size: 0.2rem;
          color: #999;
          // 最多两行
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }

  &-content {
    background: #f4f5f7;
    // background: url(~@/assets/game/bg.png) 100% no-repeat;
    background-size: 100% 100%;
    // 上方圆角
    border-radius: 0.5rem 0.5rem 0 0;
    padding: 0.4rem;
    &-title {
      font-size: 0.25rem;
      font-weight: bold;
      line-height: 1.8;
    }
    &-item {
      margin-top: 0.2rem;
      position: relative;
      &-box {
        padding: 0.2rem 0;
        &-title {
          font-size: 0.24rem;
          font-weight: bold;
          line-height: 1.8;
          position: absolute;
          transform: translateY(-70%);
        }
        &-data {
          margin-top: 0.3rem;
          font-size: 0.2rem;
          color: #999;

          &-box {
            width: 100%;
            display: flex;
            &-item {
              width: 50%;
              padding: 0 0.1rem;
              padding: 0 0.3rem;
              &-icon {
                height: 0.3rem;
              }
            }
          }

          &-card {
            &-top {
              color: #666;
              font-size: 0.25rem;
              // font-weight: bold;
              line-height: 1.8;
              text-align: center;
            }
            &-center {
              height: 2.3rem;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 0.1rem;
              &-img {
                // width: 1.8rem;
                height: 100%;
                // border-radius: 0.1rem;
                overflow: hidden;
              }
            }
            &-bottom {
              margin-top: 0.1rem;
              height: 0.5rem;
              &-group {
                display: flex;
                justify-content: space-around;
                align-items: center;
              }
            }
          }
          &-select {
            margin-top: 0.2rem;
            display: flex;
            align-items: center;
          }

          &-setting {
            display: flex;
            justify-content: space-between;
            align-items: center;
            &-text {
              flex-shrink: 0;
            }
          }
        }
      }
    }
  }

  ::v-deep .van-grid-item__content {
    padding: 0.05rem;
    background: rgba(0, 0, 0, 0);
  }

  ::v-deep .van-radio__label {
    flex-shrink: 0;
    margin-left: 2px;
  }
}

::v-deep .van-nav-bar {
  background-color: rgb(172, 185, 233) !important;
}
</style>
